// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProposalRequest
 */
export interface CreateProposalRequest {
    /**
     * Snapshot of the section's current value from document_content (arbitrary JSON: string, object, or array).
     * @type {any}
     * @memberof CreateProposalRequest
     */
    original_value: any | null;
    /**
     * The vendor's proposed replacement value, as authored text. Free-form (may be JSON text); stored and displayed verbatim, not parsed structurally.
     * @type {string}
     * @memberof CreateProposalRequest
     */
    proposed_value: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProposalRequest
     */
    rationale: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProposalRequest
     */
    section_reference: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProposalRequest
     */
    vendor_company: string;
    /**
     * DTA version this proposal belongs to
     * @type {string}
     * @memberof CreateProposalRequest
     */
    version: string;
}

/**
 * Check if a given object implements the CreateProposalRequest interface.
 */
export function instanceOfCreateProposalRequest(value: object): value is CreateProposalRequest {
    if (!('original_value' in value) || value['original_value'] === undefined) return false;
    if (!('proposed_value' in value) || value['proposed_value'] === undefined) return false;
    if (!('rationale' in value) || value['rationale'] === undefined) return false;
    if (!('section_reference' in value) || value['section_reference'] === undefined) return false;
    if (!('vendor_company' in value) || value['vendor_company'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function CreateProposalRequestFromJSON(json: any): CreateProposalRequest {
    return CreateProposalRequestFromJSONTyped(json, false);
}

export function CreateProposalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProposalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'original_value': json['original_value'],
        'proposed_value': json['proposed_value'],
        'rationale': json['rationale'],
        'section_reference': json['section_reference'],
        'vendor_company': json['vendor_company'],
        'version': json['version'],
    };
}

export function CreateProposalRequestToJSON(json: any): CreateProposalRequest {
    return CreateProposalRequestToJSONTyped(json, false);
}

export function CreateProposalRequestToJSONTyped(value?: CreateProposalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original_value': value['original_value'],
        'proposed_value': value['proposed_value'],
        'rationale': value['rationale'],
        'section_reference': value['section_reference'],
        'vendor_company': value['vendor_company'],
        'version': value['version'],
    };
}
